import { Box } from '@material-ui/core';
import { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';

import { Dropdown } from '@components';
import { content } from '@content';

import { ModuleCreateHeaderHandle, ModuleCreateHeaderProps } from './ModuleCreateHeader.props';
import { useStyles } from './ModuleCreateHeader.styles';
import { FormValues } from './ModuleCreateHeader.types';

export const ModuleCreateHeader = (
  { className, onChange, actions, disabled = false }: ModuleCreateHeaderProps,
  ref: React.Ref<ModuleCreateHeaderHandle>,
): JSX.Element => {
  const styles = useStyles();
  const { control, trigger, clearErrors } = useForm<FormValues>();

  useImperativeHandle(
    ref,
    () => ({
      validate() {
        trigger();
      },
      clear() {
        clearErrors();
      },
    }),
    [trigger, clearErrors],
  );

  return (
    <Box className={`${styles.moduleHeader} ${className}`}>
      <Box>
        <Dropdown title={content.actions} options={actions} disabled={disabled} />
      </Box>
    </Box>
  );
};

export default forwardRef(ModuleCreateHeader);
